// src/main.js
import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import { setRouter } from '@/api';
import store from './store'
import i18n, { loadLanguageAsync } from './i18n';
import WebFont from 'webfontloader';
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/styles.css';
import axios from 'axios';
import '@fortawesome/fontawesome-free/css/all.css'

axios.defaults.withCredentials = true;
axios.defaults.baseURL = process.env.VUE_APP_API_URL || '/storesafe';

const app = createApp(App);

setRouter(router);

WebFont.load({
  google: {
    families: ['Rajdhani:300,400,500,600,700']
  }
});

app.use(router);
app.use(store);
app.use(i18n);

// Load default English translations before mounting
loadLanguageAsync('en').then(() => {
  app.mount('#app');
}).catch((error) => {
  console.error('Failed to load default translations:', error);
  // Mount anyway with fallback
  app.mount('#app');
});